import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const alarmSuggestionReducer: AppReducer<'AlarmSuggestion'> = (
    state = InitialState.AlarmSuggestion,
    action
): typeof state => {
    switch (action.type) {
        case 'AlarmSuggestionAcceptRejected/Load/Started':
            return {
                ...state,
                loading: true,
                success: false,
                errorCode: '' 
            };
        case 'AlarmSuggestionAcceptRejected/Load/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,  
                errorCode: ''                
            };
        case 'AlarmSuggestionAcceptRejected/Load/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: action.payload.errorCode
               
            };
        case 'AlarmSuggestionAcceptRejected/Load/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: ''               
            };
        default:
            return state;
    }
};
